import styled from 'styled-components'

export const Page = styled.main`
  width: 100%;
  padding-bottom: 60px;
`

export const HeroImage = styled.img`
  width: 100%;
  height: min(52vw, 520px);
  min-height: 260px;
  display: block;
  object-fit: cover;
`

export const Container = styled.article`
  width: min(860px, calc(100% - 36px));
  margin: 0 auto;
  padding: 38px 0;

  h1 {
    margin: 8px 0 12px;
    color: #1c212b;
    font-size: clamp(32px, 5vw, 50px);
    line-height: 1.05;
  }
`

export const Breadcrumb = styled.div`
  color: #e90000;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
`

export const Subtitle = styled.p`
  margin: 0;
  color: #6e7683;
  font-size: 18px;
  line-height: 1.55;
`

export const OfferBox = styled.div`
  margin: 28px 0;
  padding: 22px;
  border: 1px solid #eceef1;
  border-radius: 16px;
  background: #fafbfc;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  span,
  small {
    display: block;
    margin-top: 5px;
    color: #747c88;
  }

  a {
    flex: 0 0 auto;
    padding: 13px 18px;
    border-radius: 10px;
    background: #e90000;
    color: #fff;
    font-size: 12px;
    font-weight: 800;
  }

  @media (max-width: 620px) {
    align-items: stretch;
    flex-direction: column;
  }
`

export const Price = styled.div`
  color: #e90000;
  font-size: 28px;
  font-weight: 900;

  del {
    margin-left: 10px;
    color: #a4aab3;
    font-size: 14px;
    font-weight: 500;
  }
`

export const Intro = styled.p`
  margin: 26px 0;
  color: #3c4450;
  font-size: 18px;
  line-height: 1.7;
`

export const Content = styled.div`
  color: #3c4450;
  font-size: 16px;
  line-height: 1.8;

  p {
    margin: 0 0 18px;
  }
`

export const State = styled.div`
  width: min(860px, calc(100% - 36px));
  margin: 70px auto;
  padding: 30px;
  border: 1px solid #e5e8ec;
  border-radius: 14px;
  color: #747d89;
  text-align: center;
`
